import { useRouter } from "next/router";
import { toast } from "react-hot-toast";
import { useState } from "react";
import axios from "axios";
import { getIdToken } from "../../utils/firebaseAuth";
import { useModal } from "../../context/ModalContext";
import { Button, SecondaryButton } from "@jammable/ui-core";
import { Spinner } from "@jammable/ui-components/Loader";

const DeleteConversionModal = ({ conversion }) => {
  const [loading, setLoading] = useState(false);
  const { closeModal } = useModal();
  const [error, setError] = useState(null);
  const router = useRouter();

  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      <div className="tw-text-xl tw-font-black">Delete Cover</div>
      {error && <div className="error-message">{error}</div>}
      <div className="tw-mb-1 tw-leading-6">
        Are you sure you want to delete your cover? This is not reversible.
      </div>
      <div className="tw-flex tw-gap-2">
        <SecondaryButton
          onClick={() => {
            closeModal("delete-conversion-modal");
          }}
          type="submit"
          className="tw-w-full tw-h-11 tw-rounded-full"
        >
          Cancel
        </SecondaryButton>
        <Button
          onClick={async () => {
            const token = await getIdToken();
            setLoading(true);
            axios
              .delete(`/api/conversion/deleteConversion`, {
                headers: { Authorization: token },
                params: {
                  conversionId: conversion._id,
                },
              })
              .then(() => {
                router.push(`/history`);
                toast.success("Cover deleted successfully!");
                setTimeout(() => {
                  setLoading(false);
                }, 1500);
              })
              .catch((err) => {
                // toast.error(
                //   "Something went wrong. Please try again or contact support."
                // );
                if (err?.response?.data?.message) {
                  setError(err.response.data.message);
                }
                setLoading(false);
              });
          }}
          type="submit"
          className="tw-w-full tw-bg-red-500 tw-border-none hover:tw-bg-red-600 tw-h-11 tw-rounded-full"
        >
          {loading ? (
            <Spinner className="tw-border-white tw-border-3" size={4} />
          ) : (
            "Delete Cover"
          )}
        </Button>
      </div>
    </div>
  );
};

export default DeleteConversionModal;
